"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createHref = exports.SpinButton = exports.ExactButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _merchButton = require("@site/pattern-library-core/merch-button");
/**
 * Local Imports
 */

const CTAContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CTAContainer",
  class: "pl-c1dq6w8e"
});
const createHref = query => {
  if (typeof window !== 'undefined') {
    const url = new URL('/domainsearch/find', window.location.origin);
    url.searchParams.set('itc', 'site_search_dpp');
    url.searchParams.set('domainToCheck', query);
    return url.href;
  }
};
exports.createHref = createHref;
const ExactButton = ({
  searchQuery,
  exactButtonProps
}) => {
  if (!exactButtonProps) return;
  const merchButtonHref = createHref(searchQuery);
  const {
    id,
    _name,
    text,
    itemTrackingCode
  } = exactButtonProps;
  return /*#__PURE__*/_react.default.createElement(CTAContainer, {
    "data-partial": "tealctas"
  }, /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, {
    id: id,
    _name: _name,
    href: merchButtonHref,
    text: text,
    design: "primary",
    size: "small",
    ariaLabel: `shop-now-${searchQuery}`,
    itemTrackingCode: itemTrackingCode
  }));
};
exports.ExactButton = ExactButton;
ExactButton.propTypes = {
  searchQuery: _propTypes.default.string.isRequired,
  exactButtonProps: _propTypes.default.object.isRequired
};
const SpinButton = ({
  domainEntry,
  spinButtonProps
}) => {
  if (!spinButtonProps) return;
  const {
    id,
    _name,
    text
  } = spinButtonProps;
  const domainName = domainEntry?.Fqdn;
  const spinsMerchHref = createHref(domainName);
  return /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, {
    id: id,
    _name: _name,
    href: spinsMerchHref,
    text: text,
    design: "secondary",
    size: "small",
    ariaLabel: `shop-now-${domainName}`
  });
};
exports.SpinButton = SpinButton;
SpinButton.propTypes = {
  domainEntry: _propTypes.default.object.isRequired,
  spinButtonProps: _propTypes.default.object.isRequired
};